export default {
  "event.header": "イベント",
  "event.eventDate": "開催日",
  "event.articleImage.pdf.link": "クリックするとPDFが開きます",
  "event.openDate.title": "日時",
  "event.venue.title": "会場",
  "event.eventPdf.title": "イベントPDF",
  "event.articleLinkUrl.title": "（外部サイトが開きます）",
  "event.entryDeadline.title": "申込締切",
  "event.program.title": "プログラム",
  "event.speaker.title": "登壇者",
  "event.targetPerson.title": "対象者",
  "event.admissionFee.title": "参加費",
  "event.capacity.title": "定員",
  "event.organizers.title": "主催",
  "event.articleContact.title": "お問い合わせ先",

  "event.footer.head1": "LINK-J",
  "event.footer.head2": "最新イベント情報を配信",
  "event.footer.body.newsletter": "イベントお知らせメール登録",

  "event.list.title": "イベント一覧 | LINK-J",
  "event.list.description":
    "イベント一覧は、LINK-J主催共催イベント情報に加え、LINK-J特別会員（特別会員A、特別会員B）等がライフサイエンスビルディングシリーズ等の施設で開催しているイベント内容を掲載しています。",
  "event.list.siteName": "LINK-J",
  "event.list.banner": "イベント",
  "event.list.location.title": "開催形式：",
  "event.list.location.venuesAll": "全て",
  "event.list.location.tokyoNihonbashi": "東京日本橋​",
  "event.list.location.west": "大阪・関西",
  "event.list.location.online": "オンライン",
  "event.list.category.label": "カテゴリー",
  "event.list.category.all": "イベント一覧",
  "event.list.category.main": "LINK-J主催・共催",
  "event.list.category.coSponsorship": "LINK-J協賛・協力",
  "event.list.category.memberEvent": "特別会員開催",
  "event.list.category.eventsMember": "メンバー開催",
  "event.list.category.attend": "出展・参加",
  "event.list.category.archive": "過去イベント",

  "event.list.pastEvents.filter.category": "カテゴリー",
  "event.list.pastEvents.filter.category.all": "全て",
  "event.list.pastEvents.filter.category.main": "LINK-J主催・共催",
  "event.list.pastEvents.filter.category.coSponsorship": "LINK-J協賛・協力",
  "event.list.pastEvents.filter.category.memberEvent": "特別会員開催",
  "event.list.pastEvents.filter.category.attend": "出展・参加",
  "event.list.pastEvents.filter.location": "開催形式",
  "event.list.pastEvents.filter.location.all": "全て",
  "event.list.pastEvents.filter.location.tokyoNihonbashi": "東京日本橋",
  "event.list.pastEvents.filter.location.west": "大阪・関西",
  "event.list.pastEvents.filter.location.online": "オンライン",
  "event.list.pastEvents.filter.year": "年指定",
  "event.list.pastEvents.filter.year.all": "全て",
  "event.list.pastEvents.filter.month": "月指定",
  "event.list.pastEvents.filter.month.all": "全て",
  "event.list.pastEvents.submit.label": "表示する",

  "event.list.noMatchingEvents": "該当するイベントはありません",
  "event.list.failedToRetrieveInformation": "情報の取得に失敗しました",

  // 特別会員開催イベント
  "event.memberEvent.header": "特別会員開催イベント",
  "event.memberEvent.articleLinkText": "詳細・参加申込",

  // BBT
  "event.bbt.list.title": "イベント一覧（BBT） | LINK-J",
  "event.bbt.list.title.suffix": " | BBTイベント | LINK-J",
  "event.bbt.main.list.title.suffix":
    " | イベント ｜Blockbuster TOKYO レポート",
  "event.bbt.specialMemberEvent.list.title.suffix":
    " | 特別会員開催イベント ｜Blockbuster TOKYO レポート",
  "event.bbt.list.title.suffix.bbt":
    " | BBTイベント | ｜Blockbuster TOKYO イベント",
  "event.bbt.list.title.archive": "過去イベント（BBT） | LINK-J",
  "event.bbt.list.description":
    "創薬・医療領域のスタートアップ支援・コミュニティ活性化｜Blockbuster TOKYO イベント・プログラム",
  "event.bbt.list.banner": "イベント・プログラム",
  "event.bbt.list.category.all": "イベント・プログラム",
  "event.bbt.list.category.main": "BBT主催",
  "event.bbt.list.category.collaboratedWithBbt": "collaborated with BBT",
  "event.bbt.list.category.supportedByBbt": "supported by BBT",

  "event.bbt.header": "イベント・プログラム",
} as const;
